import { render, staticRenderFns } from "./AdminTraits.vue?vue&type=template&id=423b7b62&scoped=true&"
import script from "./AdminTraits.vue?vue&type=script&lang=js&"
export * from "./AdminTraits.vue?vue&type=script&lang=js&"
import style0 from "./AdminTraits.vue?vue&type=style&index=0&id=423b7b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b7b62",
  null
  
)

export default component.exports